
import React, { useRef, useState } from 'react';
import Tooltip from '../ui/Tooltip';

type NavItemProps = {
  icon: React.ElementType;
  label: string;
  active?: boolean;
  collapsed?: boolean;
  onClick?: () => void;
  tourTarget?: string;
};

const NavItem: React.FC<NavItemProps> = ({
  icon: Icon,
  label,
  active = false,
  collapsed = false,
  onClick,
  tourTarget
}) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [hover, setHover] = useState(false);

  return (
    <>
      <button
        ref={buttonRef}
        onClick={onClick}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onFocus={() => setHover(true)}
        onBlur={() => setHover(false)}
        data-tour-target={tourTarget}
        className={`
          ${collapsed ? 'w-10 h-10 flex items-center justify-center rounded-2xl mb-0.5' : 'w-full flex items-center gap-3 px-3 py-2 rounded-xl'}
          text-sm
          ${active
            ? 'bg-blue-600 text-white dark:bg-blue-600 dark:text-white'
            : 'text-zinc-700 dark:text-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-700/50 hover:text-zinc-700 dark:hover:text-white'}
        `}
      >
  {collapsed ? <Icon size={20} strokeWidth={1.5} /> : <Icon size={18} strokeWidth={1.5} />}
        {!collapsed && label}
      </button>
      {collapsed && buttonRef.current && (
        <Tooltip 
          anchorRef={buttonRef} 
          open={hover} 
          side="right" 
          offset={8}
          customClassName={typeof window !== 'undefined' && document.documentElement.classList.contains('dark') ? 'bg-blue-600 text-white border-blue-700' : ''}
        >
          {label}
        </Tooltip>
      )}
    </>
  );
};

export default NavItem;